import server from "../../../integration/server/server-services";
import * as angular from "angular";

function openModal($uibModal: angular.ui.bootstrap.IModalService, file: string, controller: string, controllerAs: string) {
    $uibModal.open({
        templateUrl: '/presentation/routes/user/' + file,
        controller,
        controllerAs,
        keyboard: false,
        backdrop: 'static',
        backdropClass: 'loginBackdrop',
        animation: false,
        windowClass: 'loginModal'
    });
}

export function PreVerifyUserController($uibModal: angular.ui.bootstrap.IModalService){
    openModal($uibModal, 'verifyUser.html', 'VerifyUserController', 'verifyUserCtrl');
}
PreVerifyUserController.$inject = ['$uibModal'];

export function PreVerifySystemUserController($uibModal: angular.ui.bootstrap.IModalService){
    openModal($uibModal, 'verifyUser.html', 'VerifySystemUserController', 'verifyUserCtrl');
}
PreVerifySystemUserController.$inject = ['$uibModal'];

export function PreRequestResetUserPasswordController($uibModal: angular.ui.bootstrap.IModalService){
    openModal($uibModal, 'requestresetpassword.html', 'RequestResetUserPasswordController', 'resetPWCtrl');
}
PreRequestResetUserPasswordController.$inject = ['$uibModal'];

export function PreResetUserPasswordController($uibModal: angular.ui.bootstrap.IModalService){
    openModal($uibModal, 'requestresetpassword.html', 'ResetUserPasswordController', 'resetPWCtrl');
}
PreResetUserPasswordController.$inject = ['$uibModal'];

export function VerifyUserController($routeParams: angular.route.IRouteParamsService, server: server, $window: angular.IWindowService){
    const vm = this;
    const username = $routeParams.username;
    const token = $routeParams.token;

    vm.verifyAndSetPassword = verifyAndSetPassword;
    vm.username = username;

    function verifyAndSetPassword(){
        server.verifyAndSetPassword(username, vm.password.password1, token)
            .then(function(response){
                    $window.location.href = '/';
                    vm.createPasswordFailed = false;
                },
                function(response){
                    if (response.status === 400) {
                        vm.createPasswordErrorMessage = response.data;
                        vm.createPasswordFailed = true;
                    }else{
                        vm.createPasswordErrorMessage = 'Uspesifisert feil';
                    }
                });
    }
}
VerifyUserController.$inject = ['$routeParams', 'server', '$window'];

export function VerifySystemUserController($routeParams: angular.route.IRouteParamsService, server: server, $window: angular.IWindowService){
    const vm = this;
    const username = $routeParams.username;
    const token = $routeParams.token;

    vm.verifyAndSetPassword = verifyAndSetPassword;
    vm.username = username;
    vm.requireName = true;

    function verifyAndSetPassword(){
        server.verifySystemCreatedAndSetPassword(username, vm.password.password1, token, vm.password.name)
            .then(function(response){
                    $window.location.href = '/';
                },
                function(response){
                    vm.setPasswordFailed = true;
                });
    }
}
VerifySystemUserController.$inject = ['$routeParams', 'server', '$window'];

export function RequestResetUserPasswordController($routeParams: angular.route.IRouteParamsService, server: server, $window: angular.IWindowService){
    const vm = this;
    vm.submit = requestReset;
    vm.setPassword = setPassword;

    if ($routeParams.username && $routeParams.token) {
        vm.requestOk = true;
        vm.username = $routeParams.username;
        vm.password = {
            token : $routeParams.token
        };
    }

    function requestReset(){
        server.requestPasswordReset(vm.emailAddress).then(function(){
                vm.requestOk = true;
                vm.username = vm.emailAddress;
            },
            function(errorResponse){
                vm.setPasswordFailed = true;
            });
    }

    function setPassword() {
        server.resetPassword(vm.username, vm.password.password1, vm.password.token)
            .then(() => postSetPasswordSuccessAction($window),
                function(errorResponse){
                    if (errorResponse.status === 400) {
                        vm.badToken = true;
                    } else {
                        vm.setPasswordFailed = true;
                    }

                });
    }
}
RequestResetUserPasswordController.$inject = ['$routeParams', 'server', '$window'];

export function ResetUserPasswordController($routeParams: angular.route.IRouteParamsService, server: server, $window: angular.IWindowService){
    const vm = this;
    vm.setPassword = setPassword;
    vm.requestOk = true;
    vm.emailAddress = $routeParams.username;
    vm.password = {
        token : $routeParams.token,
        username: $routeParams.username
    };

    function setPassword() {
        server.resetPassword(vm.password.username, vm.password.password1, vm.password.token)
            .then(() => postSetPasswordSuccessAction($window),
                errorResponse => {
                    if (errorResponse.status === 400) {
                        vm.badToken = true;
                    }
                });
    }
}
ResetUserPasswordController.$inject = ['$routeParams', 'server', '$window'];

const postSetPasswordSuccessAction = ($window: angular.IWindowService) => {
    return $window.location.href = ('/');
};
